import { AffiliationCommission } from '@monorepo/types';
import { getEnv } from '@hub/helpers/getters.store';
import AffiliationService from '@hub/services/entities/affiliation-service';
import { EntityStore } from '../base/entity-store';

export default class AffiliationCommissions extends EntityStore<
  AffiliationService,
  AffiliationCommission
> {
  constructor() {
    const {
      apiFactory: { affiliationService },
    } = getEnv();

    super(affiliationService);
  }
}
